import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class GlobalEventsService {

    private _isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public showIsLoggedInEmitter: Observable<boolean> = this._isLoggedIn.asObservable();

    constructor() {
    }

    showIsLoggedIn(show: boolean) {
        this._isLoggedIn.next(show);
    }

}
